import { Box, TextField, Typography, Tooltip } from "@mui/material";
import React, { useState } from "react";
import Button from "@mui/material/Button";
import ResultTextField from "./ResultTextField";
import ResultBar from "./ResultBar";
import { getStreamingTitleWithLink } from "../common/common";

function YoutubeLinkFromUrl() {
  const [open, setOpen] = useState(false);
  const [streamingUrl, setStreamingUrl] = useState("");
  const [streamingTitle, setStreamingTitle] = useState("");
  const [urlErrorMsg, setUrlErrorMsg] = useState("");

  const handleStreamingURLChange = (event: any) => {
    setStreamingUrl(event.target.value);
    setUrlErrorMsg("");
  };

  const handleSearchButtonClick = () => {
    const YOUTUBE_API_KEY = "AIzaSyAgpvRCo2DPO4XUc2nmdU7fMzDC1AJKtno";
    const YOUTUBE_API_URL = "https://www.googleapis.com/youtube/v3/videos";
    const YOUTUBE_API_PART = "&part=snippet";

    const pattern = /\?v=([^&]+)/;
    const result = streamingUrl.match(pattern);
    setUrlErrorMsg("");
    if (result !== null) {
      const videoId = result[1];
      const query = `${YOUTUBE_API_URL}?id=${videoId}&key=${YOUTUBE_API_KEY}${YOUTUBE_API_PART}`;
      fetch(query)
        .then((response) => response.json())
        .then((responseData) => {
          setStreamingTitle(responseData.items[0].snippet.title);
        });
    } else {
      setUrlErrorMsg("無効なURL");
    }
  };

  const handleClickCopyTitleWithLink = () => {
    setOpen(true);
  };

  const handleCloseCopyTitleWithLink = () => {
    setOpen(false);
  };

  const getStreamingTitleWithLinkWrapper = () =>
    getStreamingTitleWithLink(streamingTitle, streamingUrl);

  return (
    <Box
      m="0.5rem"
      p="0.5rem"
      sx={{ backgroundColor: "#FFFFFF" }}
      boxShadow={3}
    >
      <Typography variant="h2">Youtube配信タイトル+リンク生成</Typography>
      <TextField
        id="youtube-url"
        sx={{
          margin: 1,
          whiteSpace: "nowrap",
        }}
        label="Youtubeの配信URLを入力"
        value={streamingUrl}
        error={urlErrorMsg !== ""}
        helperText={urlErrorMsg}
        style={{ minWidth: "60%" }}
        variant="standard"
        onChange={handleStreamingURLChange}
      />
      <Tooltip title="指定されたYoutube配信URLから配信タイトルを取得">
        <span>
          <Button
            variant="contained"
            color="primary"
            sx={{
              margin: 2,
            }}
            disabled={!streamingUrl}
            onClick={handleSearchButtonClick}
          >
            Search
          </Button>
        </span>
      </Tooltip>
      <div />
      <ResultTextField
        id="youtube-title-link"
        label="wiki用配信タイトル+リンク"
        getOutputText={getStreamingTitleWithLinkWrapper}
        handleClick={handleClickCopyTitleWithLink}
        tooltip="クリップボードにコピー"
        style={{ minWidth: "40%" }}
      />
      <ResultBar
        open={open}
        handleClose={handleCloseCopyTitleWithLink}
        result={streamingTitle}
        successMessage="クリップボードにコピーしました"
        errorMessage="配信タイトルが設定されていません。配信URLを確認して下さい"
      />
    </Box>
  );
}

export default YoutubeLinkFromUrl;
